module.exports = __webpack_public_path__ + "assets/img/ja-7ee9c861.png";